import script from "./UserInfoDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserInfoDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./UserInfoDropdown.vue?vue&type=style&index=0&id=c9eb6cba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9eb6cba"]])

export default __exports__